module.exports = __webpack_public_path__ + "static/media/generalSurgery-image3@3x.479c2522.png";